package com.bikompanion.data.analytics.web

/** The identity and session fields GA4 needs alongside every web event. */
internal data class WebAnalyticsContext(
    val clientId: String,
    val sessionId: String,
    val engagementTimeMillis: Long,
)
